import { createApp, h } from "vue";
import Tabs from "./Tabs.vue";

const els = document.querySelectorAll(".js-tabs");
els.forEach((el) => {
  //grab slots
  const children = {};
  const slots = el.querySelectorAll("[data-slot]");
  slots.forEach((slot) => {
    children[slot.dataset.slot] = () =>
      h(slot.tagName.toLowerCase(), { innerHTML: slot.innerHTML });
  });

  const a = h(
    Tabs,
    {
      headingId: el.dataset.headingId,
      tabs: JSON.parse(el.dataset.tabs),
      theme: el.dataset.theme,
    },
    children
  );

  const app = createApp(a);
  app.mount(el);
});
